var cannotLoadAjax = "Can not process your request";
 var makeText = 'Select Make';
 var yearText = 'Select Year';
 var modelText = 'Select Model';
 var loadingText = 'Loading';
 var engineText = 'Select Engine';
 var toolText = 'Own a different scanner? Select here.';
 var makeTextMX = 'Marca';
 var yearTextMX = 'Año';
 var modelTextMX = 'Modelo';
 var loadingTextMX = 'Cargando';
 var engineTextMX = 'Motor';
 var toolTextMX = '¿Tiene un escáner diferente? Seleccione aquí.';
 var cannotLoadAjaxMX = "No se puede procesar su solicitud";
 const disclaimerMsg =
    '<strong>Disclaimer</strong>: The coverage checker gives a general idea of what your tool can do with your vehicle. Because we update our tools often, what you see here might not match what’s in your tool.<br><br>For the most up-to-date coverage, make sure your tool has the latest firmware before using the coverage checker: <a class="text-danger" href="https://innova-electronics.helpscoutdocs.com/article/2692-innova-obd2-scan-tool-updates" target="_blank" rel="noopener">Update your tool here</a>. We present this information to the best of our knowledge, but it is not guaranteed.';
 const disclaimerMsgMX =
    '<strong>Aviso legal</strong>: El verificador de cobertura ofrece una idea general de lo que su herramienta puede hacer con su vehículo. Dado que actualizamos nuestras herramientas con frecuencia, lo que ve aquí podría no coincidir con lo que tiene su herramienta.<br><br>Para obtener la cobertura más actualizada, asegúrese de que su herramienta tenga el firmware más reciente antes de usar el verificador de cobertura: <a class="text-danger" href="https://innova-electronics.helpscoutdocs.com/article/2692-innova-obd2-scan-tool-updates" target="_blank" rel="noopener">Actualice su herramienta aquí</a>. Presentamos esta información según nuestro mejor conocimiento, pero no está garantizada.';

var usTools =  [{val:"0x031C",text:"1000"},{val:"0x03AE",text:"3011"},{val:"0x03A3",text:"3013"},{val:"0x03A3",text:"3030"},{val:"0x03AE",text:"5010"},{val:"0x03A9",text:"5110"},{val:"0x03D3",text:"5210"},{val:"0x03C8",text:"5310"}
                 ,{val:"0x03B8",text:"5410"},{val:"0x03C0",text:"5510"},{val:"0x03C1",text:"5512"},{val:"0x03C5",text:"5610"},{val:"0x02D5",text:"7111"},{val:"0x0423",text:"3011RS"},{val:"0x03A9",text:"3020RS"},{val:"0x03AA",text:"3030RS"},{val:"0x03D0",text:"3040RS"}
                 ,{val:"0x03E0",text:"3100RS"},{val:"0x03E1",text:"3120RS"},{val:"0x03B8",text:"3130RS"},{val:"0x03C1",text:"3140RS"},{val:"0x03C8",text:"3150RS"},{val:"0x03C0",text:"3160RS"},{val:"0x03C1",text:"3170RS"},{val:"0x031B",text:"3210RS"}
                  ,{val:"0x031C",text:"3215RS"},{val:"0x03C5",text:"5160RS"},{val:"0x03BB",text:"5300CALAT"},{val:"0x03BA",text:"5300LAT"},{val:"0x031C",text:"6000P"},{val:"0x03D0",text:"6030P"},{val:"0x03E3",text:"6100P"}
                  ,{val:"0x03C8",text:"6200P"},{val:"0x03C0",text:"7100P"},{val:"0x0671",text:"SD29"},{val:"0x0672",text:"SD35"},{val:"0x042F",text:"SD35a"},{val:"0x042E",text:"SD39"},{val:"0x0698",text:"SDS43"},{val:"0x0480",text:"SDS43a"},{val:"0x02D7",text:"SDS50"}]
var obdDisplaySections = "obd1,diagnostics,services,additionalfeatures,livedata,specialfunctions,activetestfunctions";//remove hdobd, empty for all sections
var tabletDisplaySections = "obd1,obd2,oem,workshop"; //remove hdobd, empty for all sections
var tabletTools = ['0x02D5','0x02D6','0x02D7','0x0671','0x0672','0x0698','0x02DE','0x042F','0x042E','0x02D1',"0x0480","0x0668","0x02E2","0x02E6"];
var mxTools = [{val:"0x0672",text:"SD35"}, {val:"0x02D7",text:"SDS50"}];

$(document).ready(function () {  

    $('#coverage-checker .select2').select2({
      placeholder: {
        id: '-1', // the value of the option
        text: 'Select an option'
      }		
    });
    $("#cov-error-msg").hide();
    
    $("#us-country").click(function(){
        selectCountry("US");
    })
    $("#mx-country").click(function(){
        selectCountry("MX");
    })
    $("#chooseTool").click(function(){
        gotoTabs(2);
    })

    $(".choose-vehicle").click(function(){
      toggleVehicleEditing(false);       
      gotoTabs(3);        
    })    

    $("#Tool").change(function(){
      if($(this).val() != ""){
        $("#default-us-tool li").removeClass("active");
        $("#sku").val($(this).val());
      }
    })

    $("#default-us-tool li").click(function(){
      var sku = $(this).attr("data-product-sku");

      $("#default-us-tool li").removeClass("active");
      $(this).addClass("active");
      $("#sku").val(sku);
      $("#Tool").val("").change();
    })

    $("#Year").change(function () { 
      GetMakeSelectList();    
    });

    $("#Make").change(function () { 
      GetModelSelectList();
    });

    $("#ModelName").change(function () {      
        GetEngineTypeSelectList();     
    });

    $("#EngineType").change(function () {      
        switchSelectedVehicle();     
    });    

    $("#searchCoverageBtn").click(function(){
      searchCompatibilities();
    });

    $("#basicCoverageBtn").click(function(){
      searchBasicCoverage();
    });


    loadTools();
    GetYearSelectList();
    toggleVehicleEditing(false);   
    // var market = getMaketByToolText($("#sku").val());
    // $("#Market").val(market);
});

function selectCountry(country){
    $("#Market").val(country);
    tongleCountry(country);
    loadTools();
    GetYearSelectList();
}

function tongleCountry(country){
    country = country.toLowerCase();
    switch(country){
        case "us":
            $("#us-country").removeClass("w-bg-02").addClass("w-bg-01");
            $("#mx-country").removeClass("w-bg-01").addClass("w-bg-02");
            break;
        case "mx":
            $("#us-country").removeClass("w-bg-01").addClass("w-bg-02");
            $("#mx-country").removeClass("w-bg-02").addClass("w-bg-01");
            break;
    }
}

function switchTab(tab){
  $("a.link").removeClass("inv-btn-solid-black").addClass("inv-btn-stroke");
  $("#" + tab + "Link").removeClass("inv-btn-stroke").addClass("inv-btn-solid-black");
  $("div.content").hide();
  $("#" + tab + "Tab").show();
}

function gotoTabs(tab){
  //show Tool tab
  $("ul.nav-pills li a").removeClass("active").attr("aria-selected", "false");
  $("ul.nav-pills li a#pills-0"+ tab +"-tab").addClass("active").attr("aria-selected", "true");

    // Show the corresponding tab pane
  $('div.tab-content .tab-pane').removeClass('active show');   
  $("div.tab-content #pills-0" + tab).addClass('active show');

  scrollIntoView();
}

function scrollIntoView(){
  $("#coverage-checker")[0].scrollIntoView({
    behavior: "smooth", // Smooth scrolling animation
    block: "start"      // Align element to the top of the viewport
  }); 

  const nav = document.querySelector('.nav.nav-pills');
  const activeTab = nav?.querySelector('.nav-link.active'); 
  if (nav && activeTab) {
    const navRect = nav.getBoundingClientRect();
    const tabRect = activeTab.getBoundingClientRect();
     
    nav.scrollLeft += tabRect.left - navRect.left - navRect.width / 2 + tabRect.width / 2;
  }
}

function loadTools(){
  var market = GetMarketVal();
  var toolList = market.toLowerCase() == "us" ? usTools : mxTools;
  var items = "<option value='' >"+ getToolText('us') +"</option>";
  $.each(toolList, function (i, tool) {             
      items += "<option value='" + tool.val + "'>" + tool.text + "</option>";             
  });
  $("#Tool").html(items);  

  if(!$("#default-us-tool li").hasClass("active")){
    var sku = getToolValueByText($("#sku").val());
    $("#Tool").val(sku).change();
  }
}

function searchBasicCoverage() {
    $("#cov-error-msg").hide();
  
    var tool = $("#sku").val();
    if(tool != null && tool != undefined && tool != "" && tool.indexOf("0x") <0){
      tool = getToolValueByText(tool);
    }
   
    var isValidForm = validateCoverageForm();

    if (isValidForm) {        
      $("#basicCoverageBtn").attr('disabled','disabled');      
      $('#ModalContentAjax').modal("show");		

      var market = GetMarketVal();
      var year = $("#Year").val();
      var make = $("#Make").val();
      var modelName = $("#ModelName").val();
      var engineType = correctString($("#EngineType").val());				
      var forProductDetail = correctBool($("#ForProductDetail").val()); 
      var coverageSections = correctString($("#CoverageSections").val());      
      if(coverageSections == ""){
          coverageSections = checkTabletTool(tool) ? tabletDisplaySections : obdDisplaySections;
      }
      var requestData = {"Tool": tool,
        "Year": year,
        "Make": make,
        "Model": modelName,
        "EngineType": engineType,
        "Market": market,
        "sections": coverageSections,
        "ForProductDetail": forProductDetail};
      try{
          xhr = $.ajax({
              type: "POST",
              url: "/apps/innova-api/coverages/Search",
              headers : {'Content-Type': 'application/json'},
              dataType: "json",
              data: JSON.stringify(requestData),  
              error: function (jqXHR, exception) {
                $('#ModalContentAjax').modal("hide");
                $("#basicCoverageBtn").removeAttr('disabled');
                if (jqXHR.status == 400){
                  alert(jqXHR.responseJSON.message.description);
                }else{
                  alert(getCannotLoadText(market));
                }
              },
              success: function (result) {
                if (result.message.success) {
                  if(result.data.hasData){
                      //render result
                       $("#results").html(result.data.coverageResult);	
                       //replace disclaimer msg
                      const $target = $('#results p.text-center');
                      if ($target.length) $target.html(getDisclaimerMsg(market));

                      //  $(".selected-vehicle").html(year + " " + make + " " + modelName + " " + engineType);
                      initDropdownPopup();
                      $("#basicCoverageBtn").removeAttr('disabled');                                                 
                  }else{        
                     var notfoundMsg = market.toLowerCase()=="mx" ? "Este vehículo no es compatible." : "This vehicle is not supported.";                                             
                     $("#results").html('<p class="alert alert-danger">'+ notfoundMsg +'</p>');	                     
                  }
                  $("#results").show();                 
                } else {                                                               
                    $("#cov-error-msg").html(result.message.description);
                    $("#cov-error-msg").show(); 
                }			
                $('#ModalContentAjax').modal("hide");
                $("#basicCoverageBtn").removeAttr('disabled');
              }
          });
     
        }catch(e)
        {
          $('#ModalContentAjax').modal("hide");
          $("#basicCoverageBtn").removeAttr('disabled');
        }      
    }

    return false;
}

function searchCompatibilities() {
    $("#cov-error-msg").hide();
  
    var tool = $("#sku").val();
    if(tool != null && tool != undefined && tool != "" && tool.indexOf("0x") <0){
      tool = getToolValueByText(tool);
    }
   
    var isValidForm = validateCoverageForm();

    if (isValidForm) {        
      $("#searchCoverageBtn").attr('disabled','disabled');      
      $('#ModalContentAjax').modal("show");		

      var market = GetMarketVal();
      var year = $("#Year").val();
      var make = $("#Make").val();
      var modelName = $("#ModelName").val();
      var engineType = correctString($("#EngineType").val());				
      var forProductDetail = correctBool($("#ForProductDetail").val()); 
      var coverageSections = correctString($("#CoverageSections").val());      
      if(coverageSections == ""){
          coverageSections = checkTabletTool(tool) ? tabletDisplaySections : obdDisplaySections;
      }
      var requestData = {"Tool": tool,
        "Year": year,
        "Make": make,
        "Model": modelName,
        "EngineType": engineType,
        "Market": market,
        "sections": coverageSections,
        "ForProductDetail": forProductDetail};
      try{       
          $(".selected-vehicle-edit").html(year + " " + make + " " + modelName + " " + engineType);
          $(".selected-vehicle").html(year + " " + make + " " + modelName);// + " " + engineType
          xhr = $.ajax({
              type: "POST",
              url: "/apps/innova-api/coverages/Search",
              headers : {'Content-Type': 'application/json'},
              dataType: "json",
              data: JSON.stringify(requestData),
              error: function (jqXHR, exception) {
                $('#ModalContentAjax').modal("hide");
                $("#searchCoverageBtn").removeAttr('disabled');
                if (jqXHR.status == 400){
                  alert(jqXHR.responseJSON.message.description);
                }else{
                  alert(getCannotLoadText(market));
                }
              },
              success: function (result) {
                if (result.message.success) {
                  if(result.data.hasData){
                      //render result
                       $("#results").html(result.data.coverageResult);	

                      //replace disclaimer msg
                      const $target = $('#results p.text-center');
                      if ($target.length) $target.html(getDisclaimerMsg(market));
                                            
                      //  $(".selected-vehicle").html(year + " " + make + " " + modelName + " " + engineType);
                      initDropdownPopup();
                      $("#searchCoverageBtn").removeAttr('disabled');                                                 
                  }else{        
                     var notfoundMsg = market.toLowerCase()=="mx" ? "Este vehículo no es compatible." : "This vehicle is not supported.";                                             
                     $("#results").html('<p class="alert alert-danger">'+ notfoundMsg +'</p>');	                     
                  }
                  $("#results").show();
                  toggleVehicleEditing(true);
                  getCarImage(year, make, modelName, engineType);
                } else {                                                               
                    $("#cov-error-msg").html(result.message.description);
                    $("#cov-error-msg").show(); 
                }			
                $('#ModalContentAjax').modal("hide");
                $("#searchCoverageBtn").removeAttr('disabled');
              }
          });
     
        }catch(e)
        {
          $('#ModalContentAjax').modal("hide");
          $("#searchCoverageBtn").removeAttr('disabled');
        }      
    }

    return false;
}

function toggleVehicleEditing(editVehicle){
  if(editVehicle){
    $("#cov-vehicle-info").hide();
    $("#cov-edit-vehicle").show();  
    $(".feature-benefits").removeClass("d-none");     
  }else{
    $("#cov-vehicle-info").show();
    $("#cov-edit-vehicle").hide();  
    $(".feature-benefits").addClass("d-none");   
  }
}

function initDropdownPopup() {     
    $(".inv-coverage2 .dropdown-menu").click(function(e){
	    e.stopPropagation();
	});	
	$(".inv-coverage2 .inv-dropdown-custom-close").click(function(e){
    var dropdownToggleEl = $(this).parent(".dropdown-menu").prev("a");
    const dropdownInstance = bootstrap.Dropdown.getOrCreateInstance(dropdownToggleEl);
    dropdownInstance.hide(); // Closes the dropdown
	    //$(".inv-coverage2 .inv-dropdown-custom").removeClass('open');
	});	 
}

function validateCoverageForm() {
	var validEngine = $("#EngineType option").length > 1;
  if(validEngine){
    $("#EngineType").addClass("required");
  }else{
    $("#EngineType").removeClass("required").removeClass("w-error");
  }
       
  if(!checkRequiredFields('cov-vehicle-info')){
    return false;
  } 

  if($("#sku").val() == ""){
    $("#cov-error-msg").html("Please select a Tool");
    $("#cov-error-msg").show(); 
    return false;
  }

  return true;
}

function getCarImage(year, make, modelName, engineType){
  var requestData = {
        "Year": year,
        "Make": make,
        "Model": modelName,
        "EngineType": engineType
       };
      try{       
          xhr = $.ajax({
              type: "POST",
              url: "/apps/innova-api/vehicles/car-image",
              headers : {'Content-Type': 'application/json'},
              dataType: "json",
              data: JSON.stringify(requestData),  
              error: function (jqXHR, exception) {  
                if (jqXHR.status == 400){
                  alert(jqXHR.responseJSON.message.description);
                }else{
                  alert(getCannotLoadText(market));
                }
              },
              success: function (result) {
                $("#selected-car-image").parent("div").addClass("d-none");
                if (result.message.success) {
                  if(result.data.carImageUrl != ""){
                    //render result
                    $("#selected-car-image").attr("src", result.data.carImageUrl);	
                    $("#selected-car-image").parent("div").removeClass("d-none");
                  }
                }
              }
          });
     
        }catch(e)
        {          
        }   
}

function GetYearSelectList(selectedYear) {   
   var market = GetMarketVal();
  if(market !=''){
    var url = "/apps/innova-api/coverages/"+ market +"/Years/?r=" + Math.random();
    $.ajax({
        type: "GET",        
        url: url,
        error: function (jqXHR, exception) {
            if (jqXHR.status == 404){
              options = "<option value=''>" + getYearText(market) + "</option>";
              $("#Year").html(options).change();
            }else if (jqXHR.status == 400){
              alert(jqXHR.responseJSON.message.description);
            }else{
              alert(getCannotLoadText(market));
            }
        },
        success: function (ret) {
          if (ret.message.success) {
            var result = ret.data;          
            var options = "<option value=''>" + getYearText(market) + "</option>";
            for (var i = 0; i < result.length; i++) {
              if( result[i] == selectedYear){
                options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
              }else{
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
              }              
            }
            $("#Year").html(options);
            $("#Make").html("<option value=''>" + getMakeText(market) + "</option>");
            $("#ModelName").html("<option value=''>" + getModelText(market) + "</option>");
            $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
            switchSelectedVehicle();
          }   
        }
    });
  }
}

function GetMakeSelectList(selectedMake) {
    var market = GetMarketVal();
    var year = $("#Year").val();
    if (year == "" || market == '') {
        $("#Make").html("<option value=''>" + getMakeText(market) + "</option>");
        $("#ModelName").html("<option value=''>" + getModelText(market) + "</option>");
        $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
        $("#EngineType").change();
        $("#Make").change();
        $("#ModelName").change();       
        switchSelectedVehicle(); 

        return false;
    }
    $("#Make").html("<option value=''>" + getLoadingText(market) + "...</option>");
    var url = "/apps/innova-api/coverages/"+ market +"/" + year + "/Makes/?r=" + Math.random();
    
    //$('#ModalContentAjax').modal("show");
    xhr = $.ajax({
        type: "GET",        
        url: url,
        error: function (jqXHR, exception) {
          //$('#ModalContentAjax').modal("hide");  
          if (jqXHR.status == 404){
            options = "<option value=''>" + getMakeText(market) + "</option>";
             $("#Make").html(options).change();
          }else if (jqXHR.status == 400){
            alert(jqXHR.responseJSON.message.description);
          }else{
            alert(getCannotLoadText(market));
          }
        },
        success: function (ret) {
			    if (ret.message.success) {
            var result = ret.data;
            var options = "<option value=''>" + getMakeText(market) + "</option>"; 
            for (var i = 0; i < result.length; i++) {
              if( result[i] == selectedMake){
                options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
              }else{
                options += '<option value="' + result[i] + '">' + result[i] + '</option>';
              }               
            }
            $("#Make").html(options);
            $("#ModelName").html('<option value="">'+ getModelText(market) +'</option>');
            $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
            switchSelectedVehicle();

          }else{
            $("#Make").html("<option value=''>" + getMakeText(market) + "</option>");             
          }         

          //$('#ModalContentAjax').modal("hide");
        }
    });

}

function GetModelSelectList(selectedModel) {
    var market = GetMarketVal();
    var make = $("#Make").val();
    var year = $("#Year").val();

    if (make == "" || year == "" || market == "") {
        $("#ModelName").html("<option value=''>" + getModelText(market) + "</option>");
        $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
        $("#EngineType").change();
        $("#ModelName").change();
        switchSelectedVehicle();

        return false;
    }
    $("#ModelName").html("<option value=''>" + getLoadingText(market) + "...</option>");
    var url = "/apps/innova-api/coverages/"+ market +"/" + year + "/" + make + "/Models/?r=" + Math.random();

    //$('#ModalContentAjax').modal("show");
    $.ajax({
        type: "GET",        
        url: url,
        error: function (jqXHR, exception) {
            //$('#ModalContentAjax').modal("hide");
            if (jqXHR.status == 404){
              options = "<option value=''>" + getModelText(market) + "</option>";
              $("#ModelName").html(options).change();
            }else if (jqXHR.status == 400){
              alert(jqXHR.responseJSON.message.description);
            }else{
              alert(getCannotLoadText(market));
            }
        },
        success: function (ret) {
          if (ret.message.success) {
            var result = ret.data;
            var options = "<option value=''>" + getModelText(market) + "</option>";
            for (var i = 0; i < result.length; i++) {
                if( result[i] == selectedModel){
                  options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
                }else{
                  options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                }
            }
            $("#ModelName").html(options);
            $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
            switchSelectedVehicle();

          }else{
             $("#ModelName").html("<option value=''>" + getModelText(market) + "</option>");            
          }
          //$('#ModalContentAjax').modal("hide");
        }
    });
}

function GetEngineTypeSelectList(selectedEngine) {
    var market = GetMarketVal();
    var make = $("#Make").val();
    var year = $("#Year").val();
    var model = $("#ModelName").val();

    if (make == "" || year == "" || model == "" || market == "") {
        $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
        $("#EngineType").change();
        switchSelectedVehicle();

        return false;
    }
    $("#EngineType").html("<option value=''>" + getLoadingText(market) + "...</option>");
    var url = "/apps/innova-api/coverages/"+ market +"/" + year + "/" + make + "/" + encodeURIComponent(encodeURIComponent(model)) + "/engines/?r=" + Math.random();
        
  	//$('#ModalContentAjax').modal("show");
    $.ajax({
        type: "GET",        
        url: url,
        error: function (jqXHR, exception) {
            //$('#ModalContentAjax').modal("hide");
            if (jqXHR.status == 404){
              options = "<option value=''>" + getEngineText(market) + "</option>";
              $("#EngineType").html(options).change();
            }else if (jqXHR.status == 400){
              alert(jqXHR.responseJSON.message.description);
            }else{
              alert(getCannotLoadText(market));
            }
        },
        success: function (ret) {
          if (ret.message.success) {
            var result = ret.data;
          	var options = result.length == 1? "": "<option value=''>" + getEngineText(market) + "</option>";
            for (var i = 0; i < result.length; i++) {
                if( result[i] == selectedEngine){
                  options += '<option selected value="' + result[i] + '">' + result[i] + '</option>';
                }else{
                  options += '<option value="' + result[i] + '">' + result[i] + '</option>';
                }
            }
            $("#EngineType").html(options);
            $("#EngineType").parent("div").show();
            switchSelectedVehicle();
              
          }else{
             $("#EngineType").html("<option value=''>" + getEngineText(market) + "</option>");
            if(ret.message.code = 1003){
              //Engine Not Found
               $("#EngineType").parent("div").hide();
            }
          
          }
          //$('#ModalContentAjax').modal("hide");
        }
    });
}

function switchSelectedVehicle(){
  switchSelectedInfo("Year");  
  switchSelectedInfo("Make");  
  switchSelectedInfo("ModelName"); 
  switchSelectedInfo("EngineType");    
  if($("#Year").val() =="" || $("#Make").val() =="" || $("#ModelName").val() =="" ||  
    (($("#EngineType option").length > 0 && $("#EngineType").val() =="") || $("#EngineType option") == undefined)){ 
    $("#searchCoverageBtn").attr("disabled", "disabled");
    $("#basicCoverageBtn").attr("disabled", "disabled");
    }
  else{
    $("#searchCoverageBtn").removeAttr("disabled");
    $("#basicCoverageBtn").removeAttr("disabled");
  }
}

function switchSelectedInfo(ctrlId){
  var isValid =  $("#" + ctrlId + " option").length > 1 ||  $("#" + ctrlId ).val() != "";
  if(isValid){
     $("#" + ctrlId).removeAttr("disabled");
  }else{
      $("#" + ctrlId).attr("disabled", "disabled");
  }
}

function isSupportOneTool() {
    var isWidget = $("#SupportOneTool").val();
    if (isWidget == null || isWidget == "" || isWidget == undefined || isWidget == "undefined") {
        isWidget = false;
    }
    return isWidget;
}
function checkTabletTool(tool){
  var isTabletTool = tabletTools.find(item => { return item.toLowerCase() == tool.toLowerCase() }) != undefined;
  return isTabletTool;
}

function correctString(val){
    return (val == undefined || val == null) ? "" : val;  
}

function correctBool(val){
      return (val == undefined || val == null) ? false : val.toLowerCase() === 'true';  
}

function GetMarketVal() {
    var market = $("#Market").val();
    if (market == null || market == "" || market == undefined || market == "undefined") {
        market = "US";
    }
    return market;
}

function getToolValueByText(toolText){
   var tool = mxTools.find(x => x.text === toolText)?.val;
   if(tool == undefined){
     tool = usTools.find(x => x.text === toolText)?.val;
   };
  return tool == undefined ? toolText : tool;
}

function getMaketByToolText(toolText){
  var tool = mxTools.find(x => x.text === toolText)?.val;
  if(tool != undefined){
    return "MX";
  }
  return "US";
}

function getMakeText(market){
  return market.toLowerCase() == "mx" ?  makeTextMX : makeText;
}

function getYearText(market){
  return market.toLowerCase() == "mx" ?  yearTextMX : yearText;
}

function getModelText(market){
  return market.toLowerCase() == "mx" ?  modelTextMX : modelText;
}

function getEngineText(market){
  return market.toLowerCase() == "mx" ?  engineTextMX : engineText;
}

function getToolText(market){
  return market.toLowerCase() == "mx" ?  toolTextMX : toolText;
}

function getToolIdText(market){
  return market.toLowerCase() == "mx" ?  toolIdMX : toolIdText;
}

function getLoadingText(market){
  return market.toLowerCase() == "mx" ?  loadingTextMX : loadingText;
}
function getCannotLoadText(market){
  return market.toLowerCase() == "mx" ?  cannotLoadAjaxMX : cannotLoadAjax;
}
function getDisclaimerMsg(market){
  return market.toLowerCase() == "mx" ?  disclaimerMsgMX : disclaimerMsg;
}